import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User,Call } from '../_models';
import { Configuration } from '../configuration/configurations';

@Injectable()
export class UserService {
    baseurl: string = "";
    constructor(private http: HttpClient,
        private _configurations: Configuration) {
        //const headers=new Headers();
        //this.baseurl = "http://localhost:55370";
    }

    getAll() {
        return this.http.get<User[]>(this._configurations.baseUrlToken + `/api/User/userList`);
    }

    getById(id: string) {
        return this.http.get<User>(this._configurations.baseUrlToken + `/api/User/getuserbyid/` + id);
    }

    register(user) {

        let httpOptions = {
            headers: new HttpHeaders({
                //'Content-Type': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded'
            }),
            //params: new HttpParams().set('program_id', this.program_id)
        };
        return this.http.post(this._configurations.baseUrlToken + `/api/User/Save`, user);
    }

    savePassword(resetPassword) {
       // let Body = 'username=' + username + '&' + 'password=' + password;
        let httpOptions = {
            headers: new HttpHeaders({
                //'Content-Type': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded'
            }),
        };
        
        return this.http.post(this._configurations.baseUrlToken + `/api/User/savepassword`, resetPassword);
    }
   //Get Clent Detail By Dns
    GetClientDetailByDns(Dns: string) {
        return this.http.get<any>(this._configurations.baseUrlToken + '/api/Client/ClientDetailByDns/' + Dns + "/")
            .pipe(map(data => {
                console.log("data",data)
                return data;
            }));
    }
 
    delete(id: string) {
        return this.http.get(this._configurations.baseUrlToken + `/api/User/delete/` + id);
    }


     GetUnallotedCallLog(iDisplayLength:number,iDisplayStart:number,userId: string,phoneNumber:string,direction:string,device:string,ext:string,fromDate:string,toDate:string): Observable<any> {
       let CallFilterModel={iDisplayLength:iDisplayLength,iDisplayStart:iDisplayStart,UserId:userId,PhoneNumber:phoneNumber,Direction:direction,Device:device,Extention:ext,FromDate:fromDate,ToDate:toDate};
        return this.http.post(this._configurations.baseUrlToken  + '/api/Call/unallotedcalllog',CallFilterModel).pipe(map(data => {
                        return data;
                }));
        //return this.http.get<User>(this.baseurl + '/api/User/forgotpassword/' + username + "/");
    }

    GetLatestUnallotedCallLog(userId: string,userCallCount:number): Observable<any> {
        let CallFilterModel={UserID:userId,UserCallCount:userCallCount};
         return this.http.post(this._configurations.baseUrlToken  + '/api/Call/latestunallotedcalllog',CallFilterModel).pipe(map(data => {
                         return data;
                 }));
         //return this.http.get<User>(this.baseurl + '/api/User/forgotpassword/' + username + "/");
     }

    //Get Allocated Call
    GetallotedCallLog(iDisplayLength:number,iDisplayStart:number,userId: string,phoneNumber:string,direction:string,device:string,ext:string,fromDate:string,toDate:string): Observable<any> 
    {
        let CallFilterModel={iDisplayLength:iDisplayLength,iDisplayStart:iDisplayStart,UserId:userId,PhoneNumber:phoneNumber,Direction:direction,Device:device,Extention:ext,FromDate:fromDate,ToDate:toDate};
         return this.http.post(this._configurations.baseUrlToken  + '/api/Call/allotedcalllog',CallFilterModel).pipe(map(data => {
                         return data;
                 }));

                 
         //return this.http.get<User>(this.baseurl + '/api/User/forgotpassword/' + username + "/");
     }
     //Get Allocated History
    GetAllotedHistoryLog(iDisplayLength:number,iDisplayStart:number,userId: string,phoneNumber:string,direction:string,device:string,ext:string,fromDate:string,toDate:string): Observable<any> 
    {
        let CallFilterModel={iDisplayLength:iDisplayLength,iDisplayStart:iDisplayStart,UserId:userId,PhoneNumber:phoneNumber,Direction:direction,Device:device,Extention:ext,FromDate:fromDate,ToDate:toDate};
         return this.http.post(this._configurations.baseUrlToken  + '/api/Call/allotedhistorylog',CallFilterModel).pipe(map(data => {
                         return data;
                 }));
     }

     //Get Account List
     GetListAccounts(userId: string) {
        return this.http.get<any>(this._configurations.baseUrlToken + '/api/User/ListAccounts/' + userId + "/")
            .pipe(map(data => {
                console.log("data",data)
                return data;
            }));
    }

    UpdateCall(updatecall) {
        // let Body = 'username=' + username + '&' + 'password=' + password;
         let httpOptions = {
             headers: new HttpHeaders({
                 //'Content-Type': 'application/json',
                 'Content-Type': 'application/x-www-form-urlencoded'
             }),
         };
         
         return this.http.post(this._configurations.baseUrlToken + `/api/Call/updateCall`, updatecall);
     }
     DeviceList(serverId: string) {
        return this.http.get<any>(this._configurations.baseUrlToken + '/api/Call/deviceList/' + serverId + "/")
         .pipe(map(data => {
            console.log("data",data)
            return data;
        }));
     }
     DirectionList(serverId: string) {
        return this.http.get<any>(this._configurations.baseUrlToken + '/api/Call/directionList/' + serverId + "/")
         .pipe(map(data => {
            console.log("data",data)
            return data;
        }));
     }

     AddTaskTime(updatecall) {        
         let httpOptions = {
             headers: new HttpHeaders({                 
                 'Content-Type': 'application/x-www-form-urlencoded'
             }),
         };         
         return this.http.post(this._configurations.baseUrlToken + `/api/Call/AddTaskTime`, updatecall);
     }
}